import { render } from "./Timetable.vue?vue&type=template&id=9b1a88b0&scoped=true&lang=pug"
import script from "./Timetable.vue?vue&type=script&lang=ts"
export * from "./Timetable.vue?vue&type=script&lang=ts"

import "./Timetable.vue?vue&type=style&index=0&id=9b1a88b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b1a88b0"

export default script